/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Comulative Index component for Capacity Evaluation view

Author: Deimos Space UK

Version: 1.0
*/
import React from "react";
import { Row, Button, Card } from "reactstrap";
import Chart from "react-apexcharts";
import { ESA_COLORS } from "../../../core/models/colors";
export default function ComulativeIndex() {
  const apexLineChartWithLables = {
    chart: {
      height: 280,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    colors: ESA_COLORS,
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "smooth",
    },

    grid: {
      row: {
        colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.2,
      },
      borderColor: "#f1f3fa",
    },

    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
      title: {
        text: "Year",
      },
    },

    legend: {
      show: true,
      position: "top",
      horizontalAlign: "right",
      floating: true,
      offsetY: -25,
      offsetX: -5,
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          legend: {
            show: true,
          },
        },
      },
    ],
  };

  const apexLineChartWithLablesData = [
    {
      name: "High - 2018",
      data: [28, 29, 33, 36, 32, 32, 33],
    },
    {
      name: "Low - 2018",
      data: [12, 11, 14, 18, 17, 13, 13],
    },
    {
      name: "Low - 2018",
      data: [32, 1, 64, 13, 27, 93, 63],
    },
  ];
  return (
    <Card className="widget-flat mt-5 ">
      <Row className="pr-3 pl-3 mt-3">
        <h4 style={{color:'#003247'}} className="header-title float-left col ">COMULATIVE INDEX VS CAPACITY</h4>
        <Button style={{background:'#003247'}} className="float-right">
          <i className="uil  uil-down-arrow "></i>
        </Button>
      </Row>
      <div className="p-1 mt-2">
        <Chart
          options={apexLineChartWithLables}
          height="auto"
          width={"100%"}
          series={apexLineChartWithLablesData}
          type="line"
          className="apex-charts"
        />
      </div>
    </Card>
  );
}
